/**
 * duration.ts
 *
 * Shared duration guard for analytics events.
 *
 * The existing `loading_page_shown` dataset has a max duration_ms of
 * ~61_000_000 (~17 hours) — these come from users backgrounding a tab.
 * Same risk applies to the new `route.interactive` and
 * `server.route.slow` events introduced in BRE-4346.
 *
 * Returns `null` (not a clamped value) on invalid input so callers
 * can drop the event entirely. Clamping to a sentinel max would
 * pollute p95/p99 aggregates with synthetic peaks.
 */

export const MAX_REASONABLE_DURATION_MS = 600_000; // 10 minutes

/**
 * Returns `ms` rounded to an integer if it is a finite, non-negative
 * value at or below MAX_REASONABLE_DURATION_MS. Otherwise returns
 * `null` and the caller should skip emit.
 */
export function clampDurationMs(ms: number): number | null {
  if (!Number.isFinite(ms) || ms < 0) return null;
  if (ms > MAX_REASONABLE_DURATION_MS) return null;
  return Math.round(ms);
}
